<template>
  <el-menu style="height:100%;" @select="jump" background-color="#ebeef5">
    <menu-item v-for="(menu,key) in menus" :key="key" :url="menu.url" :icon="menu.icon" :name="menu.name" :children="menu.children"></menu-item>
  </el-menu>
</template>

<script>
  import MenuItem from '@/components/Menu/MenuItem'
  export default {
    name: "LayoutAside",
    components: {
      MenuItem
    },
    data() {
      return {
        menus: []
      };
    },
    created() {
      this.getMenu();
    },
    methods: {
      async getMenu() {
        let userInfo = JSON.parse(localStorage.getItem("userInfo"));
        let response = await this.$getJSON("/admin/menu");
        this.menus = response.data;
      },
      jump(e) {
        if (e != "Index") {
          this.$router.push({
            path: e
          });
        } else {
          this.$router.push({
            name: e
          });
        }
      }
    }
  };

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Main/LayoutAside.vue